// @ts-strict-ignore
import styled from "styled-components";

const BACKGROUND_ZINDEX = 1000;

export const OverlayWrapper = styled.div`
  width: 100%;
  z-index: ${BACKGROUND_ZINDEX};
`;

export const MenuWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export const SubMenuContainerSimple = styled.div`
  display: ${({ display }) => display};
  max-width: 1200px;
  margin: auto;
  align-items: center;
  background-color: ${({ theme }) => theme.colorPalette.black};
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);
  padding-bottom: 30px;
  height: 378px;
`;

export const ContentContainer = styled.div`
  max-width: 1365px;
  margin: 0 auto;
`;

export const SubMenuWrapper = styled.div`
  min-height: 272px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 90px;
  margin-top: 60px;
  padding: 0px 60px;
`;

export const SubMenuColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0px;
  margin-top: 0;
  & > div:first-child {
    margin-top: 0;
  }
  & > div + div {
    margin-top: 24px;
  }
`;
